export const tenseOptions = [
  { label: "Present", value: "1" },
  { label: "Preterite", value: "2" },
  { label: "Imperfect", value: "3" },
  { label: "Conditional", value: "4" },
  { label: "Future", value: "5" },
  { label: "Affirmative Imperative", value: "6" },
  { label: "Negative Imperative", value: "7" },
  { label: "Present Subjunctive", value: "8" },
  { label: "Imperfect Subjunctive", value: "9" },
  { label: "Present Progressive", value: "10" },
  { label: "Preterite Progressive", value: "11" },
  { label: "Imperfect Progressive", value: "12" },
  { label: "Conditional Progressive", value: "13" },
  { label: "Future Progressive", value: "14" },
  { label: "Present Perfect", value: "15" },
  { label: "Past Perfect", value: "16" },
  { label: "Conditional Perfect", value: "17" },
  { label: "Future Perfect", value: "18" },
  { label: "Present Perfect Subjunctive", value: "19" },
  { label: "Past Perfect Subjunctive", value: "20" },
  { label: "Informal Future", value: "21" },
];

export const categoryOptions = [
  { label: "Regular AR", value: "1" },
  { label: "Regular ER", value: "2" },
  { label: "Stem-changing and Irregular", value: "3" },
  { label: "Include Reflexive Forms", value: "4" },
];

export const pronounOptions = [
  { label: "yo", value: "1" },
  { label: "tú", value: "2" },
  { label: "vos", value: "3" },
  { label: "él/ella/usted", value: "4" },
  { label: "nosotros", value: "5" },
  { label: "vosotros", value: "6" },
  { label: "ellos/ellas/ustedes", value: "7" },
];

export const pronounOptionsForImpertive = [
  { label: "tú", value: "1" },
  { label: "vos", value: "2" },
  { label: "él/ella/usted", value: "3" },
  { label: "nosotros", value: "4" },
  { label: "vosotros", value: "5" },
  { label: "ellos/ellas/ustedes", value: "7" },
];

export const verbOptions = [
  { label: "All", value: "1" },
  { label: "Page Vocabulary", value: "2" },
  { label: "Unit Vocabulary", value: "3" },
];

export const lengthOptions = [
  { label: "10", value: "1" },
  { label: "20", value: "2" },
  { label: "50", value: "3" },
  { label: "100", value: "4" },
];
export const lengthOptionsForTeachers = [
  { label: "10", value: "1" },
  { label: "20", value: "2" }
];

export const formatTimeSpent = (milliseconds) => {
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
  const hours = Math.floor(milliseconds / (1000 * 60 * 60));

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const handleTypeText = (typeValue) => {
  switch (typeValue) {
    case "fillInTheBlank":
    case "Fill_IN_THE_Blank":
    case "Fill_in_the_Blank ":
      return "Fill in the blanks";
    case "multiChoice":
    case "Select_Correct_Response":
      return "Select the correct response";
    case "selectWhatYouHear":
    case "Select_What_You_Hear":
      return "Select what you hear";
    case "translateTheSentence":
    case "Translate_Text":
      return "Translate text";
    default:
      return "";
  }
};

export const getLabels = (selectedValues, options) => {
  return options
    .filter((opt) => selectedValues?.toString() === opt.value?.toString())
    .map((opt) => opt.label);
};

export const getEditedLabels = (selectedValues, options) => {
  return options
    .filter((opt) => selectedValues?.toString() === opt.label?.toString())
    .map((opt) => opt.label);
};

export const getLabelsMoods = (selectedValues, options) => {
  if (!selectedValues || !Array.isArray(selectedValues)) {
    return [];
  }
  return options
    .filter((opt) => selectedValues.includes(opt.value?.toString()))
    .map((opt) => opt.label);
};

export const getLabelsCategory = (selectedValues, options) => {
  return options
    .filter((opt) => selectedValues?.includes(opt.value?.toString()))
    .map((opt) => opt.label);
};


export const getMainForQuestionType = (selectedValues, options) =>
  options
    .filter((opt) => selectedValues?.includes(opt.value))
    .map((opt) => opt.main);

export const question_type_generate_more_worksheet = [
  { main: "Translate_Text", value: "1", label: "Translate text" },
  { main: "Fill_IN_THE_Blank", value: "2", label: "Fill in the blanks" },
  {
    main: "Select_Correct_Response",
    value: "3",
    label: "Select the correct response",
  },
  { main: "Select_What_You_Hear", value: "4", label: "Select what you hear" },
];

export const question_type_generate_more_worksheet_admin = [
  { label: "Translate the text", value: "Translate_Text" },
  { label: "Fill in the blank", value: "Fill_IN_THE_Blank" },
  { label: "Select Correct Response", value: "Select_Correct_Response" },
  { label: "Select What you hear", value: "Select_What_You_Hear" },
];

export const reorderOptions = (options, selectedValues) => {
  const validSelectedValues = Array.isArray(selectedValues)
    ? selectedValues
    : [];
  const selectedOptions = options.filter((opt) =>
    validSelectedValues.includes(opt.value)
  );
  const unselectedOptions = options.filter(
    (opt) => !validSelectedValues.includes(opt.value)
  );
  return [...selectedOptions, ...unselectedOptions];
};

export const BORDERCOLOR = [
  "rgb(200,109,152)",
  "rgb(146,158,227)",
  "rgb(80,233,200)",
  "rgb(238,206,151)",
];

export const initalState = {
  question: "",
  options: ["", ""],
  correct_answer: "",
  highlightWords: [],
  tenseOption: null,
  hintDetail: [{ word: "", meaning: "" }],
  wrongAnswerFeedBack: "",
  categories: null,
  pronouns: null,
  mood: null,
};

export const PronounsDetailOption = [
  {
    prounce_word: "yo",
    meaning: "",
    regularColor: "",
    colorName: "",
    correct_answer: "",
    hexColor: "",
  },
];

export const moodsOption = [
  {
    label: "Indicative",
    value: "1",
    tenseOptions: [
      {
        label: "Present",
        value: "1",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Verbs gustar", value: "4" },
          { label: "Reflexive verbs", value: "5" },
          { label: "Stem change e → ie", value: "6" },
          { label: "Stem change o → ue", value: "7" },
          { label: "Stem change e → i", value: "8" },
          { label: "Irregular “yo” verbs", value: "9" },
          { label: "Verbs followed by prepositions", value: "10" },
          { label: "Irregular verbs", value: "11" },
          { label: "Gerund", value: "12" },
          { label: "Variants of present progressive", value: "13" },
          { label: "Verbs followed by an infinitive", value: "14" },
        ],
      },
      {
        label: "Present progressive",
        value: "2",
        categoryOptions: [
          { label: "Regulars", value: "1" },
          { label: "Irregulars", value: "2" },
          { label: "Variants", value: "3" },
        ],
      },

      {
        label: "Preterite",
        value: "3",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Irregular verbs", value: "4" },
          { label: "-ir stem change verbs", value: "5" },
          { label: "-car, -gar and -zar verbs", value: "6" },
          { label: "-y stem change verbs", value: "7" },
        ],
      },
      {
        label: "Imperfect",
        value: "4",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Irregular verbs", value: "4" },
        ],
      },
      {
        label: "Present perfect",
        value: "5",
        categoryOptions: [
          { label: "Regulares", value: "1" },
          { label: "Irregulares", value: "2" },
        ],
      },
      {
        label: "Past continuous",
        value: "6",
        categoryOptions: [{ label: "Gerund", value: "1" }],
      },
      {
        label: "Future",
        value: "7",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Irregular verbs", value: "4" },
        ],
      },
      {
        label: "Future perfect",
        value: "8",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulares", value: "2" },
          { label: "Irregulares", value: "3" },
        ],
      },
      {
        label: "Conditional",
        value: "9",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Irregular verbs", value: "4" },
        ],
      },
      {
        label: "Pluperfect",
        value: "10",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulars", value: "2" },
          { label: "Irregulars", value: "3" },
        ],
      },
      {
        label: "The perfect conditional",
        value: "11",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulars", value: "2" },
          { label: "Irregulars", value: "3" },
        ],
      },
    ],
  },
  {
    label: "Subjunctive",
    value: "2",
    tenseOptions: [
      {
        label: "Present subjunctive",
        value: "1",
        categoryOptions: [
          { label: "-ar regular verbs", value: "1" },
          { label: "-er regular verbs", value: "2" },
          { label: "-ir regular verbs", value: "3" },
          { label: "Irregular verbs", value: "4" },
          { label: "Present subjunctive verbs with ojalá", value: "5" },
          { label: "Subjunctive after expression of doubt", value: "6" },
          { label: "Subjunctive with verbs of influence", value: "7" },
          { label: "Subjunctive with impersonal expressions", value: "8" },
          { label: "Relative clauses", value: "9" },
          { label: "Subjunctive with emotions", value: "10" },
          { label: "Expressions with sea", value: "11" },
          { label: "Subjunctive with adverbial clauses", value: "12" },
          { label: "Subjunctive to give advice and commands", value: "13" },
          { label: "Subjunctive with aunque", value: "14" },
        ],
      },
      {
        label: "Imperfect subjunctive",
        value: "2",
        categoryOptions: [
          { label: "Regulars", value: "1" },
          { label: "Irregulars", value: "2" },
        ],
      },
      {
        label: "Present perfect of subjunctive",
        value: "3",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulares", value: "2" },
          { label: "Irregulares", value: "3" },
        ],
      },
      {
        label: "Pluperfect subjunctive",
        value: "4",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulares", value: "2" },
          { label: "Irregulares", value: "3" },
        ],
      },
      {
        label: "The perfect conditional",
        value: "5",
        categoryOptions: [
          { label: "Past participles", value: "1" },
          { label: "Regulares", value: "2" },
          { label: "Irregulares", value: "3" },
        ],
      },
    ],
  },
  {
    label: "Imperative",
    value: "3",
    tenseOptions: [
      {
        label: "",
        value: "1",
        categoryOptions: [{ label: "Commands", value: "1" }],
      },
    ],
  },
];

// export const allCategories = () => {
//   let globalValue = 1;
//   const categories = [];

//   moodsOption.forEach((mood) => {
//     if (mood.tenseOptions && mood.tenseOptions.length > 0) {
//       mood.tenseOptions.forEach((tense) => {
//         if (tense.categoryOptions && tense.categoryOptions.length > 0) {
//           tense.categoryOptions.forEach((category) => {
//             categories.push({
//               ...category,
//               tense: tense.label,
//               mood: mood.label,
//               value: globalValue++,
//             });
//           });
//         }
//       });
//     }
//   });

//   return categories;
// };

export const allCategories = () => {
  let globalValue = 1;
  const seenCategories = new Set();

  const categories = moodsOption.flatMap((mood) =>
    mood.tenseOptions?.flatMap((tense) =>
      tense.categoryOptions?.filter((category) => {
        if (!seenCategories.has(category.label)) {
          seenCategories.add(category.label);
          return true;
        }
        return false;
      }).map((category) => ({
        ...category,
        tense: tense.label,
        mood: mood.label,
        value: globalValue++,
      }))
    ) || []
  );

  return categories;
};


// export const allTenseData = () => {
//   let globalValue = 1;
//   const allTenses = moodsOption.flatMap((mood) =>
//     mood.tenseOptions
//       ? mood.tenseOptions.map((tense) => ({
//           ...tense,
//           mood: mood.label,
//           value: globalValue++,
//         }))
//       : []
//   );
//   return allTenses;
// };

export const allTenseData = () => {
  let globalValue = 1;
  const seenTenses = new Set();

  const allTenses = moodsOption.flatMap((mood) =>
    mood.tenseOptions
      ? mood.tenseOptions
          .filter((tense) => {
            if (tense?.label !== "" && !seenTenses.has(tense.label)) {
              seenTenses.add(tense.label);
              return true;
            }
            return false;
          })
          .map((tense) => ({
            ...tense,
            mood: mood.label,
            value: globalValue++,
          }))
      : []
  );

  return allTenses;
};

export const convertHighlightsToBlanks = (
  text,
  highlights,
  replacement = "__"
) => {
  const chars = [...text];
  if (!highlights || !Array.isArray(highlights)) {
    console.warn('Highlights must be an array');
    return text; // Return original text if highlights is invalid
  }
  const sortedHighlights = [...highlights].sort((a, b) => b.start - a.start);

  // Replace each highlighted segment
  sortedHighlights.forEach((highlight) => {
    const { start, end } = highlight;

    // Validate positions
    if (start < 0 || end > chars.length || start >= end) {
      console.error(`Invalid position: start=${start}, end=${end}`);
      return;
    }

    // Replace the segment with the replacement string
    chars.splice(start, end - start, replacement);
  });

  // Join the characters back into a string
  return chars.join("");
};

export const validateEditForm = (data, nouns, hintDetail) => {
  if (!data || data.length === 0) {
    const data = {
      isValid: false,
      errors: [{ field: "questions", message: "No questions provided" }],
    };
    return data;
  }

  const errors = [];
  if (data?.type === "Fill_IN_THE_Blank") {
    if (!data?.question_audio || data?.question_audio?.length === 0) {
      errors.push({
        questionIndex: 0,
        field: "Audio",
        message: "Audio is required",
      });
    }
    if (!data?.mood || data.mood === "") {
      errors.push({
        questionIndex: 0,
        field: "Mood",
        message: "Mood is required",
      });
    }

    if (data?.mood !== "Imperative") {
      if (!data?.tense || data.tense === "") {
        errors.push({
          questionIndex: 0,
          field: "Tense",
          message: "Tense is required",
        });
      }
    }

    if (!data?.category || data.category === "") {
      errors.push({
        questionIndex: 0,
        field: "Category",
        message: "Category is required",
      });
    }
    if (!data?.pronouns || data.pronouns === "") {
      errors.push({
        questionIndex: 0,
        field: "Pronouns",
        message: "Pronouns is required",
      });
    }
    // if (!hintDetail[0] || hintDetail[0] === "" || htmlToText(hintDetail[0])) {
    //   errors.push({
    //     questionIndex: 0,
    //     field: "Hint Detail",
    //     message: "Hint detail is required",
    //   });
    // }
    if (!nouns[0] || nouns[0] === "" || htmlToText(nouns[0])) {
      errors.push({
        questionIndex: 0,
        field: "Pronouns Detail Option",
        message: "Pronoun detail is required",
      });
    }

    if (!data?.question || data.question === "") {
      errors.push({
        questionIndex: 0,
        field: "Question",
        message: "Question is required",
      });
    }
    if (!data?.wrongAnswerFeedBack || data?.wrongAnswerFeedBack === "") {
      errors.push({
        questionIndex: 0,
        field: "Wrong Answer Feedback",
        message: "Feedback for wrong answers is required",
      });
    }
    if (!data?.highlightWords || data.highlightWords?.length === 0) {
      errors.push({
        questionIndex: 0,
        field: "Highlighted Word",
        message: "Highlighted Word is missing",
      });
    }
  }

  // For other question types
  else if (
    data?.type === "Translate_Text" ||
    data?.type === "Select_Correct_Response" ||
    data?.type === "Select_What_You_Hear"
  ) {
    
    if (!data?.question_audio || data?.question_audio?.length === 0) {
      errors.push({
        questionIndex: 0,
        field: "Audio",
        message: "Audio is required",
      });
    }

    if (!data?.mood || data.mood === "") {
      errors.push({
        questionIndex: 0,
        field: "Mood",
        message: "Mood is required",
      });
    }
    if (data?.mood !== "Imperative") {
      if (!data?.tense || data.tense === "") {
        errors.push({
          questionIndex: 0,
          field: "Tense",
          message: "Tense is required",
        });
      }
    }
    if (!data?.category || data.category === "") {
      errors.push({
        questionIndex: 0,
        field: "Category",
        message: "Category is required",
      });
    }
    if (!data?.pronouns || data.pronouns === "") {
      errors.push({
        questionIndex: 0,
        field: "Pronouns",
        message: "Pronouns is required",
      });
    }
    if (!nouns[0] || nouns[0] === "" || htmlToText(nouns[0])) {
      errors.push({
        questionIndex: 0,
        field: "Pronouns Detail Option",
        message: "Pronoun detail is required",
      });
    }
    if (!data?.question || data.question === "") {
      errors.push({
        questionIndex: 0,
        field: "Question",
        message: "Question is required",
      });
    }
    if (!Array.isArray(data?.options) || data?.options.length === 0) {
      errors.push({
        questionIndex: 0,
        field: "Options",
        message: "At least one option is required",
      });
    } else if (
      !data?.options.every((option) => option && option.trim() !== "")
    ) {
      errors.push({
        questionIndex: 0,
        field: "Options",
        message: "Options cannot be empty",
      });
    }
  }

  // If it's not one of the recognized question types
  else {
    errors.push({
      questionIndex: 0,
      field: "type",
      message: "Invalid question type",
    });
  }

  return {
    isValid: errors?.length === 0,
    errors: errors,
  };
};

export const validateForm = (questionData, nouns, hintDetail) => {
  if (!questionData || questionData.length === 0) {
    const data = {
      isValid: false,
      errors: [{ field: "questions", message: "No questions provided" }],
    };
    return data;
  }

  const errors = [];

  questionData.forEach((data, index) => {
    if (data?.type === "Fill_IN_THE_Blank") {

      if (!data?.question_audio || data?.question_audio === "") {
        errors.push({
          questionIndex: 0,
          field: "Audio",
          message: "Question Audio is required",
        });
      }

      if (!data?.answer_audio || data?.answer_audio === "") {
        errors.push({
          questionIndex: 0,
          field: "Audio",
          message: "Answer Audio is required",
        });
      }

      if (!data?.mood || data.mood === "") {
        errors.push({
          questionIndex: index,
          field: "Mood",
          message: "Mood is required",
        });
      }

      if (data?.mood !== "Imperative") {
        if (!data?.tense || data.tense === "") {
          errors.push({
            questionIndex: index,
            field: "Tense",
            message: "Tense is required",
          });
        }
      }

      if (!data?.category || data.category === "") {
        errors.push({
          questionIndex: index,
          field: "Category",
          message: "Category is required",
        });
      }
      if (!data?.pronouns || data.pronouns === "") {
        errors.push({
          questionIndex: index,
          field: "Pronouns",
          message: "Pronouns is required",
        });
      }
      // if (!hintDetail[index] || hintDetail[index] === "" || htmlToText(hintDetail[index])) {
      //   errors.push({
      //     questionIndex: index,
      //     field: "Hint Detail",
      //     message: "Hint detail is required",
      //   });
      // }
      if (!nouns[index] || nouns[index] === "" ||  htmlToText(nouns[index])) {
        errors.push({
          questionIndex: index,
          field: "Pronouns Detail Option",
          message: "Pronoun detail is required",
        });
      }

      if (!data?.question || data.question === "") {
        errors.push({
          questionIndex: index,
          field: "Question",
          message: "Question is required",
        });
      }
      if (!data?.image || data?.image === "") {
        errors.push({
          questionIndex: index,
          field: "Image",
          message: "Question image is required",
        });
      }
      if (!data?.wrongAnswerFeedBack || data?.wrongAnswerFeedBack === "") {
        errors.push({
          questionIndex: index,
          field: "Wrong Answer Feedback",
          message: "Feedback for wrong answers is required",
        });
      }
      if (!data?.highlightWords || data.highlightWords?.length === 0) {
        errors.push({
          questionIndex: index,
          field: "Highlighted Word",
          message: "Highlighted Word is missing",
        });
      }
    }

    // For other question types
    else if (
      data?.type === "Translate_Text" ||
      data?.type === "Select_Correct_Response" ||
      data?.type === "Select_What_You_Hear"
    ) {
      if (!data?.question_audio || data?.question_audio === "") {
        errors.push({
          questionIndex: 0,
          field: "Audio",
          message: "Audio is required",
        });
      }
      if (!data?.mood || data.mood === "") {
        errors.push({
          questionIndex: index,
          field: "Mood",
          message: "Mood is required",
        });
      }
      if (data?.mood !== "Imperative") {
        if (!data?.tense || data.tense === "") {
          errors.push({
            questionIndex: index,
            field: "Tense",
            message: "Tense is required",
          });
        }
      }
      if (!data?.category || data.category === "") {
        errors.push({
          questionIndex: index,
          field: "Category",
          message: "Category is required",
        });
      }
      if (!data?.pronouns || data.pronouns === "") {
        errors.push({
          questionIndex: index,
          field: "Pronouns",
          message: "Pronouns is required",
        });
      }
      if (!nouns[index] || nouns[index] === "" ||  htmlToText(nouns[index])) {
        errors.push({
          questionIndex: index,
          field: "Pronouns Detail Option",
          message: "Pronoun detail is required",
        });
      }
      if (!data?.question || data.question === "") {
        errors.push({
          questionIndex: index,
          field: "Question",
          message: "Question is required",
        });
      }
      if (!data?.image || data?.image === "") {
        errors.push({
          questionIndex: index,
          field: "Image",
          message: "Question image is required",
        });
      }
      if (!Array.isArray(data?.options) || data?.options.length === 0) {
        errors.push({
          questionIndex: index,
          field: "Options",
          message: "At least one option is required",
        });
      } else if (
        !data?.options.every((option) => option && option.trim() !== "")
      ) {
        errors.push({
          questionIndex: index,
          field: "Options",
          message: "Options cannot be empty",
        });
      }
    }

    // If it's not one of the recognized question types
    else {
      errors.push({
        questionIndex: index,
        field: "type",
        message: "Invalid question type",
      });
    }
  });

  const data = {
    isValid: errors?.length === 0,
    errors: errors,
  };
  return data;
};

export const htmlToText = (text) => {
  if (!text) return;
  const tempElement = document.createElement("div");
  tempElement.innerHTML = text;

  const textContent = tempElement.textContent || tempElement.innerText;
  return textContent.length === 0;
};
